module.exports = __webpack_public_path__ + "files/86a6bc02d2cd74eb0a819d7596e65788.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/skintone-6.png
// module id = 1495
// module chunks = 60